import React, { useRef, useCallback } from 'react';
import { toCssGradient } from '../../utils/gradientUtils';

const GradientBar = ({
  colorStops,
  gradientType,
  selectedStopIndex,
  onStopSelect,
  onStopMove,
  onStopAdd,
}) => {
  const barRef = useRef(null);
  const draggingRef = useRef(null);

  const getOffsetFromEvent = useCallback((e) => {
    if (!barRef.current) return 0;
    const rect = barRef.current.getBoundingClientRect();
    const x = (e.clientX || e.touches?.[0]?.clientX || 0) - rect.left;
    return Math.max(0, Math.min(1, x / rect.width));
  }, []);

  const handleBarClick = (e) => {
    if (draggingRef.current !== null) return;
    // 스톱 마커를 클릭한 건지 확인
    if (e.target.dataset.stopIndex !== undefined) return;
    const offset = getOffsetFromEvent(e);
    onStopAdd(offset);
  };

  const handleStopMouseDown = (e, index) => {
    e.stopPropagation();
    e.preventDefault();
    onStopSelect(index);
    draggingRef.current = index;

    const handleMouseMove = (moveEvent) => {
      if (draggingRef.current === null) return;
      const offset = getOffsetFromEvent(moveEvent);
      onStopMove(draggingRef.current, offset);
    };

    const handleMouseUp = () => {
      draggingRef.current = null;
      window.removeEventListener('mousemove', handleMouseMove);
      window.removeEventListener('mouseup', handleMouseUp);
    };

    window.addEventListener('mousemove', handleMouseMove);
    window.addEventListener('mouseup', handleMouseUp);
  };

  return (
    <div style={{ position: 'relative', marginBottom: '20px' }}>
      {/* Gradient preview bar */}
      <div
        ref={barRef}
        onClick={handleBarClick}
        style={{
          height: '24px',
          borderRadius: '6px',
          background: toCssGradient({ type: gradientType, angle: 0, colorStops }),
          border: '1px solid #e5e7eb',
          cursor: 'crosshair',
          position: 'relative',
        }}
      />
      {/* Stop markers */}
      <div style={{ position: 'relative', height: '20px' }}>
        {colorStops.map((stop, index) => (
          <div
            key={index}
            data-stop-index={index}
            onMouseDown={(e) => handleStopMouseDown(e, index)}
            style={{
              position: 'absolute',
              left: `${stop.offset * 100}%`,
              top: '2px',
              transform: 'translateX(-50%)',
              width: '14px',
              height: '14px',
              borderRadius: '50%',
              backgroundColor: stop.color,
              border: selectedStopIndex === index ? '3px solid #3b82f6' : '2px solid #ffffff',
              boxShadow: '0 1px 3px rgba(0,0,0,0.3)',
              cursor: 'grab',
              zIndex: selectedStopIndex === index ? 2 : 1,
            }}
          />
        ))}
      </div>
    </div>
  );
};

export default GradientBar;
